









import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from './input'
import * as ruleNames from './constants/ruleNames'

export type Option =
  | {
      text: string | number
      value: string | number
    }
  | string
  | number

@Component
export default class SelectInput extends mixins(Input) {
  @Prop(Array) options!: Array<Option>
  @Prop(String) unselected?: string

  supportedRules: Array<string> = [ruleNames.REQUIRED]

  get innerOptions() {
    return this.options.map(o => {
      return typeof o === 'object' && o !== null ? o : { value: o, text: o }
    })
  }
}
